import { render } from "./ProvedorViews.vue?vue&type=template&id=44b3eab4&scoped=true"
import script from "./ProvedorViews.vue?vue&type=script&lang=js"
export * from "./ProvedorViews.vue?vue&type=script&lang=js"

import "./ProvedorViews.vue?vue&type=style&index=0&id=44b3eab4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b3eab4"]])

export default __exports__